import { BusinessLine } from "../shared/types/BusinessLine";
import { constants, validation } from "../shared/constants";
import { isEmptyOrSpaces, trimProvidedCharacterFromEnd } from "../shared/helpers/helpers";

export function mapBusinessLineToName(translations: any, businessLine: BusinessLine) {
    switch (businessLine) {
        case BusinessLine.Private:
            return translations.businessLines.private;
        case BusinessLine.Corporate:
            return translations.businessLines.corporate;
        case BusinessLine.Retail:
            return translations.businessLines.retail;
    }
}

export const validateAttendeeEmails = (attendees: string, allowedSuffixList: string[] = []) => {
    if (!attendees.length) {
        return true;
    }

    const emailCollection = mapStringToArray(attendees);
    const invalidEmailIndex = emailCollection.findIndex((x) => {
        return !x.match(validation.emailRegExp);
    });

    let notAllowedEmailIndex = -1;

    if (allowedSuffixList && allowedSuffixList.length > 0) {
        notAllowedEmailIndex = emailCollection.findIndex((x) => {
            return allowedSuffixList.findIndex((s) => x.endsWith(s)) === -1;
        });
    }

    return invalidEmailIndex === -1 && notAllowedEmailIndex === -1;
};

export const validateCustomerDataFields = (names: string, emails: string) => {
    if (isEmptyOrSpaces(names) && !isEmptyOrSpaces(emails)) {
        return false;
    }

    if (!isEmptyOrSpaces(names) && isEmptyOrSpaces(emails)) {
        return false;
    }

    const newNames = trimProvidedCharacterFromEnd(names, constants.customerDataSeparator);
    const newEmails = trimProvidedCharacterFromEnd(emails, constants.customerDataSeparator);

    return mapStringToArray(newNames).length === mapStringToArray(newEmails).length;
};

export const validateClientsIds = (clientsIds: string) => {
    if (!clientsIds.length) {
        return true;
    }

    const invalidClientIdIndex = mapStringToArray(clientsIds).findIndex((x) => {
        return !x.match(validation.clientIdRegExp);
    });

    return invalidClientIdIndex === -1;
};

export const validateC6 = (c6: string) => {
    if (!c6.length) {
        return true;
    }

    return validation.c6RegExp.test(c6);
};

export const validateTitle = (title: string) => {
    if (title.length === 0) {
        return true;
    }

    const invalidCharacters = ["<", ">"];

    let valid = true;
    invalidCharacters.forEach((invalidCharacter) => {
        if (title.includes(invalidCharacter)) {
            valid = false;
        }
    });

    return valid;
};

export const validateMeetingEndingDate = (endingTime: Date, maxEndingTime: Date) => {
    if (endingTime > maxEndingTime) {
        return false;
    }

    return true;
};

export const mapStringToArray = (data: string) => {
    const array = data
        .replace(validation.whitespaceRegExp, "")
        .split(constants.customerDataSeparator)
        .filter((x) => x) as string[];

    if (!array) {
        return [];
    }

    return array;
};

export const mapArrayToString = (data: string[]) => {
    return data.join("; ");
};

export const textContainsComma = (text: string) => {
    return text && text.indexOf(",") >= 0;
};
